import { faCamera, faFileCheck, faPencil } from '@fortawesome/pro-light-svg-icons'

const generateMediaAndCopyTabBarItems = (campaignId: number, campaignPermissions: object) => {
  // @ts-expect-error TS2339
  const { ad_copy, media, media_selection, photos_and_plans } = campaignPermissions

  return [
    {
      hidden: !photos_and_plans?.manage || !(media?.manage ?? true) || false,
      href: `#/campaigns/${campaignId}/edit/media`,
      icon: faCamera,
      key: 'media',
      title: 'Photos & Plans',
    },
    {
      hidden: !media_selection?.manage || !(media?.manage ?? true) || false,
      href: `#/campaigns/${campaignId}/edit/media-selection`,
      icon: faFileCheck,
      key: 'media-selection',
      title: 'Media Selection',
    },
    {
      hidden: !ad_copy?.manage || false,
      href: `#/campaigns/${campaignId}/edit/adcopy`,
      icon: faPencil,
      key: 'adcopy',
      title: 'Ad Copy',
    },
  ]
}

export default generateMediaAndCopyTabBarItems
